module.exports = function() {
  return new Worker(__webpack_public_path__ + "b2da007105a0e037bb05.worker.js");
};